import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../layout/LoadingComponent';
import AdminContent from './AdminContent';

export default observer(function AdminPage() {
    const { username } = useParams<{ username: string }>();
    const { profileStore } = useStore();
    const { loadingProfile, loadProfile, profile, setActiveTab } = profileStore;

    useEffect(() => {
        if (username)
            loadProfile(username);
        return () => {
            setActiveTab(0);
        }
    }, [loadProfile, username, setActiveTab])

    if (loadingProfile) return <LoadingComponent content='Loading admin pages...' />

    return (
        <Grid>
            <Grid.Column width={16}>
                {profile &&
                    <>
                        <AdminContent profile={profile} />
                    </>}
            </Grid.Column>
        </Grid>
    )
})